'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DashedLabel(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    { className: 'dashed-label m-y-6 m-x-8' },
    _react2.default.createElement('div', { className: 'border-line-left' }),
    _react2.default.createElement(
      'div',
      { className: 'closed-text p-x-4' },
      _react2.default.createElement(
        'p',
        { className: 'm-bottom-0' },
        _react2.default.createElement(
          _Small2.default,
          { use: 'help' },
          children
        )
      )
    ),
    _react2.default.createElement('div', { className: 'border-line-right' })
  );
}

DashedLabel.propTypes = {
  children: _react.PropTypes.node.isRequired
};

exports.default = DashedLabel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/js/components/labels/DashedLabel.js
// module id = 406
// module chunks = 0 1